// Plan allowances for the UI, read from the same shared file the server uses
// (builderslab/shared/plans.json) so the two can never drift apart.
//
// Previously the UI hardcoded `?? 5` as the credit-limit fallback, which meant a
// failed profile fetch rendered a "5/5" plan that matches no plan we sell. Use
// these constants instead of literals at call sites.

import PLANS from '../../builderslab/shared/plans.json';

export { PLANS };

/** Message credits included in the free plan — the safe default limit to show. */
export const FREE_MESSAGE_CREDITS = PLANS.free.messageCredits;

/** Integration credits included in the free plan. */
export const FREE_INTEGRATION_CREDITS = PLANS.free.integrationCredits;

/** Message-credit allowance for a tier, falling back to the free plan. */
export function messageCreditsForTier(tier) {
  return PLANS[tier]?.messageCredits ?? FREE_MESSAGE_CREDITS;
}

/** Integration-credit allowance for a tier, falling back to the free plan. */
export function integrationCreditsForTier(tier) {
  return PLANS[tier]?.integrationCredits ?? FREE_INTEGRATION_CREDITS;
}
